import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpmanualpack0getGetManualPacksResponseSchema = jsonObject
export type tcpmanualpack0getGetManualPacksResponse = z.infer<typeof tcpmanualpack0getGetManualPacksResponseSchema>
